module.exports = __webpack_public_path__ + "resources/audio-file-5e5200f5dc464684fee3c3f8a98edc3a.svg";